export default class TrustindexCommon {
	static setCommonConstants()
	{
		this.script = document.currentScript;
		this.loadedCss = [];
		this.loadedJs = [];
	}

	static addCSS(url, callback, checkIframe = false, error = null)
	{
		if (typeof this.loadedCss === 'undefined') {
			this.loadedCss = [];
		}

		if (!url || this.loadedCss.indexOf(url) !== -1) {
			return callback ? callback() : null;
		}

		let link = document.createElement('link');

		link.type = 'text/css';
		link.rel = 'stylesheet';
		link.href = url;

		if (checkIframe && window !== window.parent && this.isCrossDomainIframe()) {
			window.parent.document.head.appendChild(link);
		} else {
			document.head.appendChild(link);
		}

		document.head.appendChild(link);

		if ('function' === typeof callback) {
			link.addEventListener('load', callback);
		}

		if ('function' === typeof error) {
			link.addEventListener('error', error);
		}

		return this.loadedCss.push(url);
	}

	static addJS(url, callback, checkIframe = false)
	{
		if (typeof this.loadedJs === 'undefined') {
			this.loadedJs = [];
		}

		if (!url || this.loadedJs.indexOf(url) !== -1) {
			return callback ? callback() : null;
		}

		let script = document.createElement('script');

		script.type = 'text/javascript';
		script.src = url;

		if (checkIframe && window !== window.parent && this.isCrossDomainIframe()) {
			window.parent.document.head.appendChild(script);
		} else {
			document.head.appendChild(script);
		}

		if (callback) {
			script.addEventListener('load', callback);
		}

		return this.loadedJs.push(url);
	}

	static openWindow(url)
	{
		let a = document.createElement('a');

		a.href = url;
		a.target = '_blank';
		a.rel = 'noopener noreferrer nofollow';

		return a.click();
	}

	static getScriptSelector(id)
	{
		return '[src*=".trustindex."][src*="'+ id +'.js"],[data-src*=".trustindex."][data-src*="'+ id +'.js"]';
	}

	static getScriptKey(script)
	{
		let src = (script.getAttribute('data-src') || script.getAttribute('src'));
		let key = src.replace(/.+\?([^&]+)/, '$1');
		if (!key || key === src || key.indexOf('=') !== -1) {
			return null;
		}

		return key;
	}

	static getCDNUrl()
	{
		if (typeof window.TrustindexCdnUrl !== 'undefined' && window.TrustindexCdnUrl) {
			return window.TrustindexCdnUrl;
		}

		if (typeof this.cdnUrl !== 'undefined' && this.cdnUrl) {
			return this.cdnUrl;
		}

		let defaultUrl = 'https://cdn.trustindex.io/';
		let url = defaultUrl;

		if (this.script && this.script.src) {
			let parts = this.script.src.split('/');
			parts.pop();
			url = parts.join('/') + '/';
		}

		if (-1 === url.indexOf('trustindex.')) {
			url = defaultUrl;
		}

		let isProxyUrl = -1 !== url.indexOf('?');
		let savedUrl = null;

		try {
			if (!isProxyUrl && typeof sessionStorage !== 'undefined') {
				savedUrl = sessionStorage.getItem('ti-cdn-url');
			}
		}
		catch (e) {
			// Safari/iOS/restricted context may block sessionStorage.
			savedUrl = null;
		}

		if (savedUrl) {
			return savedUrl;
		}

		this.cdnUrl = url;

		try {
			if (!this.isAdminUrl() && url !== defaultUrl && !isProxyUrl && typeof sessionStorage !== 'undefined') {
				sessionStorage.setItem('ti-cdn-url', url);
			}
		}
		catch (e) {
			// Safari/iOS/restricted context may block sessionStorage.
		}

		return url;
	}

	static getWidgetUrl(pid)
	{
		if (typeof pid === 'undefined') {
			return null;
		}

		return this.getCDNUrl() + 'widgets/' + pid.substring(0, 2) + '/' + pid + '/';
	}

	static getDecodedHtml(html)
	{
		let txt = document.createElement('textarea');
		txt.innerHTML = html;

		return txt.value;
	}

	static decodeTextNodes(element)
	{
		let walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);

		while (walker.nextNode()) {
			walker.currentNode.nodeValue = this.getDecodedHtml(walker.currentNode.nodeValue.replace(/</g, '&lt;'));
		}
	}

	static getRelativeTime(timestamp, locale)
	{
		let intervals = locale.split('|'); // %d %s ago|today|day|days|week|weeks|month|months|year|years
		let format = intervals.shift(); // %d %s ago
		let todayStr = intervals.shift(); // "today"

		let periods = [
			86400, // day ago
			604800, // week ago
			2419200, // month ago
			31536000 // year ago
		];

		let seconds = (new Date().getTime() / 1000) - timestamp;
		for (let i = periods.length - 1; i >= 0; i--) {
			if (seconds >= periods[i]) {
				let amount = Math.floor(seconds / periods[i]);
				let intervalIndex = i * 2;

				if (amount > 1) {
					intervalIndex++;
				}

				return format.replace('%d', amount).replace('%s', intervals[intervalIndex]);
			}
		}

		return todayStr;
	}

	static getDevicePixelRatio()
	{
		let ratio = 1;

		if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
			ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
		} else if (window.devicePixelRatio !== undefined) {
			ratio = window.devicePixelRatio;
		}

		return Math.min(ratio, 2);
	}

	static getDefaultAvatarUrl()
	{
		let r = (Math.floor(Math.random() * 10) + 1);

		return this.getCDNUrl() + 'assets/default-avatar/noprofile-' + (r < 10 ? '0' : '') + r + '.svg';
	}

	static getDefaultCompanyAvatarUrl()
	{
		return this.getCDNUrl() + 'companies/default_avatar.jpg';
	}

	static getPageLanguage()
	{
		return this.getWidgetLanguage(document.documentElement.lang);
	}

	static getUserLanguage()
	{
		return this.getWidgetLanguage(navigator.language || navigator.userLanguage || document.documentElement.lang);
	}

	/**
	 * Convert a page / browser language tag (eg. "zh-Hant-TW") to a widget language code.
	 */
	static getWidgetLanguage(languageTag)
	{
		let tag = (languageTag || 'en').toLowerCase();

		// Chinese is the only language with a separate widget language per script
		if (tag.startsWith('zh')) {
			return /-(hant|tw|hk|mo)\b/.test(tag) ? 'zh_TW' : 'zh';
		}

		return tag.substr(0, 2);
	}

	/**
	 * Convert a widget language code (eg. "zh_TW") to a locale tag the Intl API accepts.
	 */
	static getLocaleTag(language)
	{
		return (language || 'en').replace('_', '-');
	}

	static isAdminUrl(url)
	{
		let currentLocation = url ? new URL(url) : location;

		return /(admin|stage[0-9kw])\.trustindex/.test(currentLocation.hostname) && -1 === currentLocation.href.indexOf('test/widget.html');
	}

	static isWordpressAdminUrl(url)
	{
		let currentLocation = url ? new URL(url) : location;

		return -1 !== currentLocation.href.indexOf('settings.php&tab=free-widget-configurator');
	}

	static isAdminEditUrl(url)
	{
		if (typeof url === 'undefined') {
			url = location.href;
		}

		return -1 !== url.indexOf('widget/edit');
	}

	static isTestWidgetUrl(url)
	{
		if (typeof url === 'undefined') {
			url = location.href;
		}

		return -1 !== url.indexOf('test/widget.html');
	}

	static isInIframe()
	{
		return window.top !== window.self;
	}

	static isAttributeEnabled(element, attributeName)
	{
		let value = element.getAttribute(attributeName);

		return null !== value && -1 === ['0', 'false'].indexOf(value.toLowerCase());
	}

	static isCrossDomainIframe()
	{
		// not an iframe
		if (window.parent === window) {
			return false;
		}

		try {
			let parentLocation = new URL(window.parent.location);

			return (parentLocation.protocol !== location.protocol || parentLocation.hostname !== location.hostname || parentLocation.port !== location.port);
		} catch (error) {
			console.error(error);

			return null;
		}
	}

	static isMobileDevice()
	{
		if (this.isAdminUrl() && !this.isAdminEditUrl()) {
			return !!document.querySelector('.widget-editor.mobile');
		}

		return /mobi/i.test(navigator.userAgent || navigator.vendor || window.opera);
	}

	static show(element, display)
	{
		element.style.display = display || '';
	}

	static hide(element)
	{
		element.style.display = 'none';
	}

	static isEditorPreview()
	{
		if (this.isAdminUrl() || this.isTestWidgetUrl() || this.isWordpressAdminUrl()) {
			return true;
		}

		return -1 !== location.href.indexOf('elementor-preview=');
	}

	static onFirstActivity(callback)
	{
		if (this.hadFirstActivity) {
			return callback();
		}

		if (typeof this.firstActivityCallbacks === 'undefined') {
			this.firstActivityCallbacks = [];

			let events = [ 'keydown', 'mousemove', 'wheel', 'touchmove', 'touchstart' ];
			let handler = () => {
				events.forEach(eventName => window.removeEventListener(eventName, handler));

				this.hadFirstActivity = true;
				this.firstActivityCallbacks.forEach(activityCallback => activityCallback());
				this.firstActivityCallbacks = [];
			};

			events.forEach(eventName => window.addEventListener(eventName, handler, { passive: true }));
		}

		return this.firstActivityCallbacks.push(callback);
	}

	static onApproachingViewport(element, callback, distance = 300) {
		if (typeof IntersectionObserver === 'undefined' || this.isInLoadTriggerZone(element, distance)) {
			return callback();
		}

		let observer = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting) {
				observer.disconnect();
				callback();
			}
		}, {rootMargin: distance + 'px'});

		return observer.observe(element);
	}

	static convertToDialog(element)
	{
		if (!element || 'DIALOG' === element.tagName) {
			return element;
		}

		let dialog = document.createElement('dialog');
		Array.from(element.attributes).forEach(attribute => dialog.setAttribute(attribute.name, attribute.value));
		dialog.append(...element.childNodes);

		Object.assign(dialog.style, {
			border: '0',
			padding: '0',
			margin: '0',
			maxHeight: 'none',
			overflow: 'visible'
		});

		if (element.parentNode) {
			element.replaceWith(dialog);
		}

		return dialog;
	}

	/**
	 * Crawlers never scroll and never generate mouse or touch events, so the
	 * activity based lazy-load would keep the widget content out of the DOM
	 * forever. They have to render immediately instead.
	 */
	static isCrawler()
	{
		if (typeof this.cacheIsCrawler !== 'undefined') {
			return this.cacheIsCrawler;
		}

		let crawlerPatterns = [
			// search engines executing JavaScript
			'googlebot', 'googleother', 'google-inspectiontool', 'storebot-google', 'bingbot', 'bingpreview',
			'applebot', 'duckduckbot', 'yandexbot', 'baiduspider', 'petalbot', 'seznambot', 'slurp',

			// AI crawlers and assistants
			'gptbot', 'oai-searchbot', 'chatgpt-user', 'claudebot', 'claude-web', 'claude-user',
			'claude-searchbot', 'anthropic-ai', 'perplexity', 'duckassistbot', 'meta-externalagent',
			'meta-externalfetcher', 'bytespider', 'amazonbot', 'ccbot', 'cohere-ai', 'youbot', 'diffbot',
			'mistralai-user', 'imagesiftbot', 'timpibot', 'omgilibot', 'webzio-extended',

			// auditing tools and link preview services
			'ahrefsbot', 'semrushbot', 'screaming frog', 'dataforseo', 'chrome-lighthouse', 'prerender',
			'facebookexternalhit', 'twitterbot', 'linkedinbot', 'slackbot', 'discordbot', 'telegrambot', 'embedly',
		];

		this.cacheIsCrawler = new RegExp(crawlerPatterns.join('|'), 'i').test(navigator.userAgent || '');

		return this.cacheIsCrawler;
	}

	static isWebpSupported(callback)
	{
		if (typeof this.cacheWebpSupported !== 'undefined') {
			return callback(this.cacheWebpSupported);
		}

		let done = (result) => {
			this.cacheWebpSupported = result;
			return callback(result);
		};

		let img = new Image();
		img.onload = () => done(img.width > 0 && img.height > 0);
		img.onerror = () => done(false);
		img.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
	}

	static isDarkMode()
	{
		return window?.matchMedia?.('(prefers-color-scheme:dark)')?.matches ? true : false;
	}

	static isReducedMotion()
	{
		return window?.matchMedia?.('(prefers-reduced-motion:reduce)')?.matches ? true : false;
	}

	static waitForVisibility(content, callback, timeout = 0)
	{
		if (content.offsetWidth > 0) {
			if (timeout) {
				return setTimeout(callback, timeout);
			}

			return callback();
		}

		new ResizeObserver(function(entries) {
			if (entries[0].target.offsetWidth > 0) {
				callback();
				this.disconnect();
			}
		}).observe(content);
	}

	 static isInLoadTriggerZone(element, distance = 1200) {
		let slideContainer = element.closest('.x-slide.slider-section');
		if (slideContainer && slideContainer.classList.contains('is-current-slide')) {
			return true;
		}

		let bounding = element.getBoundingClientRect();

		return bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + distance
			&& bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + distance;
	}

	static getProxyUrl(server = 'eu') {
		if (!server) {
			const regions = {'Europe': 'eu'};
			const region = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/')[0];
			server = regions[region] || 'eu';
		}

		return config.gdpr_profiles[server] ? config.gdpr_profiles[server].url + 'trustindex-1stp/cdn-loader.php' : '';
	}

	static disableBodyScroll() {
		if (typeof this.oldBodyScrollAttributes !== 'undefined' || !this.isBodyScrollApplicable()) {
			return;
		}

		this.oldBodyScrollAttributes = {
			documentElement: {
				overflow: document.documentElement.style.overflow,
				position: document.documentElement.style.position,
				height: document.documentElement.style.height,
			},
			body: {
				overflowX: document.body.style.overflowX,
				height: document.body.style.height,
			}
		};

		document.documentElement.style.overflow = 'hidden';
		document.documentElement.style.position = 'relative';
		document.documentElement.style.height = 'unset';
		document.body.style.overflowX = 'unset';
		document.body.style.height = 'unset';
	}

	static enableBodyScroll() {
		if (typeof this.oldBodyScrollAttributes === 'undefined') {
			return;
		}

		for (let element in this.oldBodyScrollAttributes) {
			for (let attribute in this.oldBodyScrollAttributes[element]) {
				document[element].style[attribute] = this.oldBodyScrollAttributes[element][attribute];
			}
		}

		delete this.oldBodyScrollAttributes;
	}

	static isBodyScrollApplicable() {
		// body & html has inline overflow hidden
		if (
			'hidden' === document.documentElement.style.overflow ||
			'hidden' === document.documentElement.style.overflowX ||
			'hidden' === document.body.style.overflow ||
			'hidden' === document.body.style.overflowX
		) {
			return false;
		}

		// html has overflow hidden
		let style = window.getComputedStyle(document.documentElement);
		if ('hidden' === (style.overflow || "").split(' ')[0] || 'hidden' === (style.overflowX || "")) {
			return false;
		}

		// body has overflow hidden
		style = window.getComputedStyle(document.body);
		if ('hidden' === (style.overflow || "").split(' ')[0] || 'hidden' === (style.overflowX || "")) {
			return false;
		}

		return true;
	}

	static getFetchApi()
	{
		if (typeof this.fetchApi !== 'undefined' && this.fetchApi) {
			return this.fetchApi;
		}

		let iframe = document.createElement('iframe');
		document.body.appendChild(iframe);
		this.fetchApi = iframe.contentWindow.fetch.bind(window);
		iframe.remove();

		return this.fetchApi;
	}

	static request(url, method = 'GET') {
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();

			xhr.open(method, url, true);

			xhr.onload = function () {
				if (xhr.status >= 200 && xhr.status < 300) {
					resolve(xhr.responseText);
				} else {
					resolve(false);
				}
			};

			xhr.onerror = function () {
				resolve(false);
			};

			xhr.send();
		});
	}
};